import { IconBlockquote as n, IconSubscript as c, IconSuperscript as e, IconH6 as l, IconH5 as i, IconH4 as t, IconH3 as s, IconH2 as r, IconH1 as a, IconBrandYoutube as u, IconAlignRight as d, IconAlignLeft as I, IconAlignCenter as h, IconClearFormatting as v, IconPhoto as g, IconLink as k, IconListNumbers as b, IconList as p, IconStrikethrough as L, IconUnderline as m, IconItalic as A, IconBold as C, IconCode as o } from "./index516.mjs";
const B = {
  code: {
    icon: o,
    controls: "code"
  },
  codeBlock: {
    icon: o,
    controls: "code-block"
  },
  bold: {
    icon: C,
    controls: "bold"
  },
  italic: {
    icon: A,
    controls: "italic"
  },
  underline: {
    icon: m,
    controls: "underline"
  },
  strike: {
    icon: L,
    controls: "strike"
  },
  unorderedList: {
    icon: p,
    controls: "list",
    value: "bullet"
  },
  orderedList: {
    icon: b,
    controls: "list",
    value: "ordered"
  },
  link: {
    icon: k,
    controls: "link"
  },
  image: {
    icon: g,
    controls: "image"
  },
  clean: {
    icon: v,
    controls: "clean"
  },
  alignCenter: {
    icon: h,
    controls: "align",
    value: "center",
    noActive: !0
  },
  alignLeft: {
    icon: I,
    controls: "align",
    value: "",
    noActive: !0
  },
  alignRight: {
    icon: d,
    controls: "align",
    value: "right",
    noActive: !0
  },
  video: {
    icon: u,
    controls: "video"
  },
  h1: {
    icon: a,
    controls: "header",
    value: "1"
  },
  h2: {
    icon: r,
    controls: "header",
    value: "2"
  },
  h3: {
    icon: s,
    controls: "header",
    value: "3"
  },
  h4: {
    icon: t,
    controls: "header",
    value: "4"
  },
  h5: {
    icon: i,
    controls: "header",
    value: "5"
  },
  h6: {
    icon: l,
    controls: "header",
    value: "6"
  },
  sup: {
    icon: e,
    controls: "script",
    value: "super"
  },
  sub: {
    icon: c,
    controls: "script",
    value: "sub"
  },
  blockquote: {
    icon: n,
    controls: "blockquote"
  }
};
export {
  B as CONTROLS
};
